import React, { FC, useCallback, useMemo } from 'react';
import { useTrackPreviewActions } from '../../../../../utils/hooks/bi/useTrackPreviewActions';
import { ClickOrigin } from '../../../../../utils/hooks/bi/useTrackPreviewActions/useTrackPreviewActions.types';
import { isBoard } from '../../../../../utils/media-manager-sdk/boards';
import { IconButton, WixIcons } from '../../../../../components/common';
import multipleBoardsImage from './multiple-boards.svg?url';
import multipleItemsImage from './multiple-items.svg?url';
import styles from './MultipleItemsTopPart.scss';
import { IOuter } from './MultipleItemsTopPart.types';

export const MultipleItemsTopPart: FC<IOuter> = ({ isExpandable, onFilesExpand, items }) => {
  const { trackPreviewActionsExpandButtonClicked } = useTrackPreviewActions();
  const handleOpenExpandedViewClick = useCallback(() => {
    onFilesExpand();
    trackPreviewActionsExpandButtonClicked(ClickOrigin.MoreInfo);
  }, [onFilesExpand, trackPreviewActionsExpandButtonClicked]);

  const multipleItemsIcon = useMemo(() => (isBoard(items[0]) ? multipleBoardsImage : multipleItemsImage), [items]);

  return (
    <div className={styles.wrapperNewLayout} data-hook="multiple-items-top-part">
      <div className={styles.innerNewLayout}>
        <img className={styles.image} src={multipleItemsIcon} width="84" height="100" alt="" />

        {isExpandable && (
          <IconButton
            className={styles.expandButtonNewLayout}
            size="small"
            skin="standard"
            priority="secondary"
            onClick={handleOpenExpandedViewClick}
            dataHook="expand-button"
          >
            <WixIcons.Preview />
          </IconButton>
        )}
      </div>
    </div>
  );
};
